import React from "react";
import { useTranslation } from "Shared/util/custom-hooks";
import { SettingsCard } from "Shared/components/cards";

type IntegrationSettingsCardProps = {
    supportEmailAddress: string;
    className?: string;
};

const IntegrationSettingsCard = ({
    supportEmailAddress,
    className,
}: IntegrationSettingsCardProps) => {
    const t = useTranslation((x) => x.sales_methods.card);

    return (
        <SettingsCard
            header={{
                text: t.integration,
            }}
            content={t.format(t.integration_description, {
                supportEmailAddress,
            })}
            className={className || ""}
        />
    );
};

export default IntegrationSettingsCard;
